import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../Pages/DashboardHeader/DboardHeader";
import Sidebarcomp from "../../Pages/Sidebar/Sidebar";
import "./SuperAdmin.css";
import { Outlet } from "react-router-dom";

function SuperAdmin() {
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve the access token and user role from localStorage
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    // Check if the user is authenticated and is a super-admin
    if (!accessToken || !userType || userType !== "Super Admin") {
      // If not authenticated or not a super-admin, redirect to login page
      navigate("/");
    }
  }, [navigate]);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="layout d-flex">
      <Sidebarcomp isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <div
        className={`main-components d-flex flex-column ${
          isCollapsed ? "full-width" : ""
        }`}
      >
        <DashboardHeader />
        
        <Outlet />
      </div>
    </div>
  );
}

export default SuperAdmin;
